module.exports = __webpack_public_path__ + "static/media/ceilings_advantages.efbada77.jpg";